import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {AssessmentModel} from "../../../interfaces/AssessmentModel";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Employee} from "../../../interfaces/Employee";
import {MatDialog} from "@angular/material/dialog";
import {CounselingService} from "../counseling.service";
import {DatePipe, TitleCasePipe} from "@angular/common";
import {MatSnackBar} from "@angular/material/snack-bar";
import {EmployeeService} from "../../../services/employee.service";
import {Centre} from "../../../interfaces/Centres";
import {CentreService} from "../../../services/centre.service";
import {takeUntil} from "rxjs/internal/operators/takeUntil";
import {Subject} from "rxjs/internal/Subject";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {
    ViewIndividualAssessmentComponent
} from "../components/view-individual-assessment/view-individual-assessment.component";
import firebase from "firebase/compat";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {ViewGroupSessionComponent} from "../components/view-group-session/view-group-session.component";
import {ViewAssessmentComponent} from "../components/view-assessment/view-assessment.component";
import {ChildService} from "../../../components/child/child.service";
import {FullChild} from "../../../interfaces/FullChild";
import {MatSelectChange} from "@angular/material/select";
import {ChartConfiguration} from "chart.js/dist/types";
import {
    ViewFollowUpAssessmentComponent
} from "../components/follow-up-question/view-follow-up-assessment/view-follow-up-assessment.component";
import Timestamp = firebase.firestore.Timestamp;
import {LogService} from "../../../services/log.service";

@Component({
    selector: 'app-counseling-child-report',
    templateUrl: './counseling-child-report.component.html',
    styleUrls: ['./counseling-child-report.component.scss']
})
export class CounselingChildReportComponent implements OnInit, OnDestroy {
    mAllIndividualData: any[] = []
    mAllGroupData: any[] = []
    mAllAssessmentData: any[] = []
    mAllFAssessmentData: any[] = [];
    displayedColumns: string[] = [ 'date','childName', 'centreName', 'type',  'Action'];
    displayedColumns2: string[] = ['date', 'children', 'centres', 'topicsCovered', 'Action'];
    displayedColumns3: string[] = ['dateOfAssessment','childName', 'centreName', 'parentsName', 'conducted_by',  'sessionType', 'Action'];
    FdisplayedColumns4: string[] = ['dateOfAssessment','childName', 'centreName',  'submittedBy',  'sessionType', 'Action'];
    types = ["Admission Rapport building counselling", "Regular Counselling", "Discharge Counselling", "Follow-up Counselling", "Others"]
    types3 = ["Admission Baseline Assessment", "Intermediate Assessment", "Discharge Assessment"]
    types4 =[ "Follow Up Assessment 1", " Follow Up Assessement 2", "Follow Up Assessment 3", "Follow Up Assessment 4", "Follow Up Assessment 5", "Follow Up Assessment 6","Follow Up Assessment 7","Follow Up Assessment 8","Follow Up Assessment 9","Follow Up Assessment 10"];


    dataSourceIndividual!: MatTableDataSource<AssessmentModel>;
    dataSourceGroup!: MatTableDataSource<AssessmentModel>;
    dataSourceAssessment!: MatTableDataSource<AssessmentModel>;
    dataSourceFAssessment!: MatTableDataSource<any>;
    counselorName = ''
    employee: Observable<Employee[]>
    centres$: Observable<Centre[]>
    destroyed$ = new Subject<void>()
    selectedCentre?: string | null = ''
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    childBycentre: Observable<FullChild[]> | undefined;
    selectedChildCode?: any;
    searchText : string = '';
    showGroup = true;
    showIndividual = true;
    showAssessment = true;
    showFAssessment = true;
    sessionType: string = '' //* Individual Type
    sessionTopics: any;  //*Group Type
    sessionType3: any;  //* Assessment Type
    sessionType4: any;  //* FAssessment Type
    mChartData: number[] = []
    mFChartData: number[] = []
    colors: any[] = [{backgroundColor: ["#0b5ba8", "#6114be", "#15dcdc"]}];
    chartconfigurationsArray: ChartConfiguration<'doughnut'>['data']['datasets'][] = []
    public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
        responsive: false
    };
    public doughnutChartLabels: string[] = ['Difficulty in Coping up', 'Not able to Cope up','Able to Cope up'];
     doughnutChartDatasets?:ChartConfiguration<'doughnut'>['data']['datasets']
     doughnutFChartDatasets?:ChartConfiguration<'doughnut'>['data']['datasets']

    constructor(private readonly matDialog: MatDialog,
                private counselingService: CounselingService,
                private readonly datePipe: DatePipe,
                private _snackBar: MatSnackBar,
                private employeeService: EmployeeService,
                private titlecasePipe: TitleCasePipe,
                private centreService: CentreService,
                private readonly childService: ChildService,
                private readonly mFirestore: AngularFirestore,
                private mLogService:LogService,
    ) {
        this.centres$ = this.centreService.getAllCentres().pipe(
            map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
        )
        this.dataSourceIndividual = new MatTableDataSource<AssessmentModel>()
        this.dataSourceGroup = new MatTableDataSource<AssessmentModel>()
        this.dataSourceAssessment = new MatTableDataSource<AssessmentModel>()
        this.dataSourceFAssessment = new MatTableDataSource<any>()
        this.employee = this.employeeService.getCounsellersFromUsers()

    }

    search() {
        if (this.selectedCentre != null) {
            this.childBycentre = this.childService.getChildListByCenter(this.selectedCentre!)
        }
    }

    ngOnInit(): void {
        // this.fetchIndividualStudentData();
        // this.fetchGroupStudentData();
      this.dataSourceIndividual.sort = this.sort;
      this.dataSourceIndividual.paginator = this.paginator;
    }



    private fetchStudentAssessmentData() {
        console.log('centreCode', this.selectedCentre)
        console.log('childCode', this.selectedChildCode)
        this.counselingService.fectchAssessmentsByChild(this.selectedChildCode.childCode!)
            .pipe(takeUntil(this.destroyed$))
            .subscribe(res => {
                // alert(res.length)z
                console.log(res)
                this.mAllAssessmentData = res
                this.dataSourceAssessment = new MatTableDataSource<AssessmentModel>(this.mAllAssessmentData)
                this.dataSourceAssessment.sort = this.sort
                this.dataSourceAssessment.paginator = this.paginator
                this.calculateGraphData(this.mAllAssessmentData)
            })
    }

    private fetchGroupStudentData(childObject: any) {
        this.counselingService.fetchGroupSessionsByChild(childObject).pipe(takeUntil(this.destroyed$)).subscribe(res => {
            this.mAllGroupData = res
            this.dataSourceGroup.data = this.mAllGroupData
            this.dataSourceGroup.sort = this.sort
            this.dataSourceGroup.paginator = this.paginator
        })
    }

    private fetchIndividualStudentData() {
        this.counselingService.fetchIndividualSessionsByChild(this.selectedChildCode.childCode!).pipe(takeUntil(this.destroyed$)).subscribe(res => {
            this.mAllIndividualData = res
            this.dataSourceIndividual.data = this.mAllIndividualData
          console.log(this.dataSourceIndividual.data)
            this.dataSourceIndividual.data = this.mAllIndividualData
            this.dataSourceIndividual.sort = this.sort
        })
    }
    private fetchStudentFAssessmentData() {
        console.log('centreCode', this.selectedCentre)
        console.log('childCode', this.selectedChildCode)
        this.counselingService.CounselingFollowUpAssessmentByChild(this.selectedChildCode.childCode!)
            .pipe(takeUntil(this.destroyed$))
            .subscribe(res => {
                // alert(res.length)z
                console.log(res)
                this.mAllFAssessmentData = res
                this.dataSourceFAssessment = new MatTableDataSource<any>(this.mAllFAssessmentData)
                this.dataSourceFAssessment.sort = this.sort
                this.dataSourceFAssessment.paginator = this.paginator
                this.calculateFGraphData(this.mAllFAssessmentData)
            })
    }
    viewDialog(element: any) {
        this.matDialog.open(ViewIndividualAssessmentComponent, {
            data: element,
            width: '800%',
            height: '90%'
        })

      let activity = {
        date: new Date().getTime(),
        section: 'Counselling Reports',
        action: 'View',
        description: `Counseling view Individual Table by user`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)
    }

    getDate(date: Date): any {
        let d = (date as unknown as Timestamp).toDate()
        let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy');
        return datePipeString
    }

    getchildNames(children: any[]): string {
        let str = ''
        children.forEach((it, index) => {
            if (children.length - 1 == index) str += it.childName + ' '
            else str += it.childName + ', '
        })
        return str
    }

    getCenterNames(centres: any): string {
        let str = ''
        centres.forEach((it: { centreName: string; }, index: number) => {
            if (centres.length - 1 == index) str += it.centreName + ' '
            else str += it.centreName + ', '
        })
        return str
    }

    getTopicsCovered(centres: any[]): string {
        let str = ''
        centres.forEach(it => {
            str += it + ' '
        })
        return str
    }

    viewDialog2(element: any) {
        this.matDialog.open(ViewGroupSessionComponent, {
            data: element,
            width: '800%',
            height: '90%'
        })
      let activity = {
        date: new Date().getTime(),
        section: 'Counselling Reports',
        action: 'View',
        description: `Counseling view Group Table by user`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)
    }

    viewAssessment(element: AssessmentModel) {
        console.log(element)
        this.matDialog.open(ViewAssessmentComponent, {
            maxHeight: '800px',
            autoFocus: false,
            data: element
        })
      let activity = {
        date: new Date().getTime(),
        section: 'Counselling Reports',
        action: 'View',
        description: `Counseling view Assessment Table by user`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)

    }
    viewFAssessment(element: AssessmentModel) {
        console.log(element)
        this.matDialog.open(ViewFollowUpAssessmentComponent, {
            maxHeight: '800px',
            autoFocus: false,
            data: element
        })
      let activity = {
        date: new Date().getTime(),
        section: 'Counselling Reports',
        action: 'View',
        description: `Counseling view Followup Assessment Table by user`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)

    }

  searchChild() {
    this.searchText = '';
  }

  SearchButton() {
    const childObject = {
      childCode: this.selectedChildCode?.childCode,
      childName: `${this.selectedChildCode?.firstName || ''} ${this.selectedChildCode?.lastName || ''}`,
      parentsName: `${this.selectedChildCode?.guardians[0]?.firstName || ''} and ${this.selectedChildCode?.guardians[1]?.firstName || ''}`
    };

    if (this.showIndividual) {
      this.fetchIndividualStudentData();
    }

    if (this.showGroup) {
      this.fetchGroupStudentData(childObject);
    }

    if (this.showAssessment) {
      this.fetchStudentAssessmentData();
      this.fetchStudentFAssessmentData();
    }

    }

    clearAll() {
    this.selectedCentre = '';
    this.selectedChildCode = ''
    }

    IndividualFilter($event: MatSelectChange) {
        if ($event.value != 'All') {
            let filteredData = this.mAllIndividualData.filter(x => x.type == $event.value)
            this.dataSourceIndividual.data = filteredData
        } else this.dataSourceIndividual.data = this.mAllIndividualData
    }

    GroupFilter($event: MatSelectChange) {
        if ($event.value != 'All') {
            let filterData2 = this.mAllGroupData.filter(x => x.type == $event.value)
            this.dataSourceGroup.data = filterData2
        } else this.dataSourceGroup.data = this.mAllGroupData
    }

    assessmentFilter($event: MatSelectChange) {
        if ($event.value != 'All') {
            this.dataSourceAssessment.data = this.mAllAssessmentData.filter(x => x.type == $event.value)
        } else this.dataSourceAssessment.data = this.mAllAssessmentData

    }
    fassessmentFilter($event: MatSelectChange) {
        if ($event.value != 'All') {
            this.dataSourceFAssessment.data = this.mAllFAssessmentData.filter(x => x.sessionType == $event.value)
        } else this.dataSourceFAssessment.data = this.mAllFAssessmentData

    }
    private calculateGraphData(data: AssessmentModel[]) {
        let totalYes = 0
        let totalNo = 0
        let totalSometimes = 0
        data.forEach(it => {
            let currentYes = it.assessment.filter((questionModel) => questionModel.ans == 'Yes').length
            let currentNo = it.assessment.filter((questionModel) => questionModel.ans == 'No').length
            let currentsometimes = it.assessment.filter((questionModel) => questionModel.ans == 'Sometimes').length
            totalYes =totalYes+=currentYes
            totalNo = totalNo += currentNo
            totalSometimes = totalSometimes += currentsometimes

        })
      this.mChartData =[totalSometimes,totalYes,totalNo,]
        this.doughnutChartDatasets= [
            {data: this.mChartData, label: '' ,backgroundColor: ["#fbc02d",  "#af1111","#00695c"]},

        ];
    }
    private calculateFGraphData(data: any[]) {
        let totalYes = 0
        let totalNo = 0
        let totalSometimes = 0
        data.forEach(it => {
            let currentYes = it.questions.filter((questionModel: { ans: string; }) => questionModel.ans == 'Yes').length
            let currentNo = it.questions.filter((questionModel: { ans: string; }) => questionModel.ans == 'No').length
            let currentsometimes = it.questions.filter((questionModel: { ans: string; }) => questionModel.ans == 'Sometimes').length
            totalYes =totalYes+=currentYes
            totalNo = totalNo += currentNo
            totalSometimes = totalSometimes += currentsometimes

        })
        this.mFChartData =[totalSometimes,totalYes,totalNo,]
        this.doughnutFChartDatasets= [
            {data: this.mFChartData, label: '' ,backgroundColor: ["#fbc02d",  "#af1111","#00695c"]},

        ];
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
